const ar_sa = {
    menu_home: "الصفحة الرئيسية",
    menu_SpeRetrieve: "ميزة الاستعلام ",
    menu_CLCRetrieve: " الصينية تصنيف الرسم البياني الاستعلام ",
    menu_AdvanceRetrieve: " بحث متقدم",
    menu_BookMarkRetrieve: " المرجعية واسترجاعها",
    menu_Notes: "معلومات النشرة",
    menu_Mylibray: "المكتبة",

    field_hit: 'ضرب ',
    field_author: 'السلطة',
    field_pubdate: ' وقت النشر ',
    field_content: ' اسم الكتاب',
    field_pages: ' الصفحات',
    field_publisher: 'الناشر : الناشر',
    field_clcno: 'رقم التصنيف ',
    field_price: 'السعر ',
    field_barcode: 'barcode',
    field_local: ' الموقع',
    field_duedate: ' التاريخ',

    field_title: 'العنوان ',
    field_callno: ' رقم الطلب',
    field_subject: ' الموضوع ',
    field_pubyear: ' سنة النشر',
    field_anyword: "أي كلمة ",
    field_cardno: ' رقم البطاقة ',
    field_rdrpin: ' كلمة السر ',
    field_fine: 'المتأخرات المتأخرة',
    field_suspendDays: ' " أيام من تاريخ انتهاء الصلاحية ',
    field_logtype: ' نوع العملية',
    field_logdate: 'تاريخ العملية',


    field_frontMatch: " في الجبهة من المباراة",
    field_exactMatch: " مطابقة دقيقة ",
    field_fuzzyRetrieve: "امض استرجاع ",

    field_labelOrder: " ترتيب",
    field_orderAsc: " تصاعدي ",
    field_orderDesc: " تنازلي",

    field_tipInputKeyword: " الرجاء إدخال الكلمات الرئيسية التي تريد",
    field_retrieve: " استرجاع",
    field_retrieveInReult: " البحث في النتائج ",

    field_recordsPerPage: "” عرض في كل صفحة ",
    field_clc: " الصينية تصنيف الرسم البياني",
    field_docType: " نوع الوثيقة",
    field_language: " اللغ",

    field_mobileMessage: "إرسال الرسائل القصيرة",
    field_shareInfoTo: " حصة",
    field_shareQQ: "تينسنت ف",
    field_shareWeChat: "سالة صغيرة ",
    field_shareWeibo: " سينا ويبو",
    field_tags: "العلامات ",

    field_printPage: "طباعة ",
    field_exportRec: " تصدير السجلات",
    field_addFavorite: "إضافة إلى المفضلة",
    field_PermanentLink: " ارتباط دائم ",
    field_btn_login: " تسجيل الدخول",
    field_btn_home: "العودة إلى الصفحة الرئيسية ",
    field_btn_closewin: "إغلاق : إغلاق النافذة الحالية",
    field_btn_action: "عملية ",
    field_btn_alipay: "Alipay ",
    field_btn_webchatPay: "رسالة صغيرة ",

    field_mylib_bookshelf: "جاك : بلدي خزانة الكتب . ",
    field_mylib_loanlist: "أنا أستعير ",
    field_mylib_reserveY: "الحجز الخاص بي",
    field_mylib_reserveJ: " بلدي السلف",
    field_mylib_finInfo: " المعلومات المالية ",
    field_mylib_loglist: "تاريخ بلادي الاقتراض",
    field_mylib_searchCon: " البحث المحفوظة ",
    field_mylib_calendar: " بلدي مكتبة التقويم",
    field_mylib_logout: 'خروج الدخول',

    field_sortfield: " نوع الحقل",
    field_tip_inputPin: " الرجاء إدخال كلمة السر الخاصة بك",
    field_tip_remeber: "تذكر لي",
    field_tip_logout: " كنت قد تركت بلدي المكتبة بأمان",
    field_tip_logoutDetail: " يمكنك الاستمرار في تصفح الكتب ، شكرا لك",
    
};

export default ar_sa;